/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useContext, useEffect, useState } from "react";
import { getDistance } from "geolib";
import MapPropsContext from "../MapPropsContext";
import useVworldCityType from "../useVworldCityType";

import "./WidgetVworldCityTypeForCenter.scss";

const WidgetVworldCityTypeForCenter = () => {
  const [label, setLabel] = useState();
  const { viewState, isEnableDistanceToClickedPoint, clickedPointIconObjects } =
    useContext(MapPropsContext);

  const { latitude, longitude, zoom } = viewState; // FIXME: zoom 레벨에 따라 도시지역 구하기?
  const [distance, setDistance] = useState();

  const { setIsEnable, setPosition } = useVworldCityType((cityType) => {
    setLabel(cityType);
  });

  useEffect(() => {
    if (zoom < 12) {
      setLabel(undefined);
      setIsEnable(false);
    } else {
      setPosition({ latitude, longitude });
      setIsEnable(true);
    }
  }, [latitude, longitude, zoom]);

  useEffect(() => {
    if (isEnableDistanceToClickedPoint && clickedPointIconObjects.length > 0) {
      const { position } = clickedPointIconObjects[0];
      setDistance(
        getDistance(
          { latitude, longitude },
          { latitude: position[1], longitude: position[0] }
        )
      );
    } else {
      setDistance(null);
    }
  }, [isEnableDistanceToClickedPoint, clickedPointIconObjects]);

  return (
    <>
      <div
        className={"widget-vworld-city-type-for-center"}
        style={{ display: label ? "" : "none" }}
      >
        <div className={"distance-label"}>{distance && `${distance} m`}</div>
        <div className={"plus"}>+</div>
        <div className={"label"}>{label}</div>
      </div>
    </>
  );
};

export default WidgetVworldCityTypeForCenter;
